module.exports = " <div v-if=canShow class=session_list_item @click=select :class=\"{ active: currentSession === sid }\" _v-2b125c89=\"\"> <avatar :src=avatar :username=sessionName _v-2b125c89=\"\"></avatar> <div class=body _v-2b125c89=\"\"> <div class=container _v-2b125c89=\"\"> <span class=name _v-2b125c89=\"\">{{ sessionName }}</span> <span class=latest_time _v-2b125c89=\"\">{{ latestTime }}</span> </div> <span class=latest_message _v-2b125c89=\"\">{{ latestMessage }}</span> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-2b125c89!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/sidebar/SessionListItem.vue
 ** module id = 339
 ** module chunks = 2
 **/